/* eslint-disable import/no-unresolved, max-len */
import { Field, Form, withFormik } from "formik";
import { bool, func, number, shape } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { resizableRoute } from "pages/_components/Resizable";
import { actions as layoutActions } from "reducers/layout";
import { actions as debinActions, selectors as debinSelectors } from "reducers/debin";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import Credential from "pages/_components/fields/credentials/Credential";
import Head from "pages/_components/Head";
import Hint from "pages/_components/hints/Hint";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import SelectedAccountsAmount from "pages/charges/_components/SelectedAccountsAmount";
import CreateCredinRecipientSummary from "pages/transfer/_components/CreateCredinRecipientSummary";
import CreateCredinSellerSummary from "pages/transfer/_components/CreateCredinSellerSummary";
import Col from "react-bootstrap/lib/Col";
import * as configUtils from "util/config";
import { calculateTotalAmountCbuList } from "util/credin";
import * as i18nUtils from "util/i18n";
import isTokenActive from "util/token";
import Yup from "yup";

const FORM_ID = "requestCredin.summary";

class GenerateCredin extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
        seller: shape({}).isRequired,
        recipients: shape({}).isRequired,
        dispatch: func.isRequired,
        id: number.isRequired,
        control: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        this.applyEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.applyEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            this.clearEmbeddedV3ShellLayout();
        }
    }

    clearEmbeddedV3ShellLayout = () => {
        const { dispatch } = this.props;
        dispatch(layoutActions.setScopes([]));
        dispatch(layoutActions.setTitleKey(""));
        dispatch(layoutActions.setHeaderTitle(""));
        dispatch(layoutActions.setHeaderSubtitle(""));
        dispatch(layoutActions.setGoBackPath(null));
        dispatch(layoutActions.setRightContentMobile(null));
    };

    applyEmbeddedV3ShellLayout = () => {
        const { embeddedInV3Shell, dispatch, isDesktop } = this.props;
        if (!embeddedInV3Shell || !isUxDashboardImprovementsEnabled()) {
            return;
        }
        dispatch(layoutActions.setScopes(["debin"]));
        if (isDesktop) {
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
            return;
        }
        dispatch(layoutActions.setHeaderTitle(""));
        dispatch(layoutActions.setTitleKey("requestCredin.title"));
        dispatch(layoutActions.setGoBackPath("/requestCredin"));
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(debinActions.setIsBackFromSummary("/requestCredin"));
    };

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ margin: "0.2rem" }}>{i18nUtils.get("requestCredin.title")}</h1>
        </div>
    );

    render() {
        const { isDesktop, fetching, seller, recipients, id, control, embeddedInV3Shell } = this.props;
        const continueButton = (
            <Col className="col-12 confirmation__content-button" lg={12} md={12} sm={12}>
                <div className="admin-content-center">
                    <Button
                        loading={fetching}
                        type="submit"
                        bsStyle="primary"
                        label="global.confirm"
                        image="images/arrowRight.svg"
                        imageStyle={isDesktop ? "mr-2" : "mr-1"}
                    />
                </div>
            </Col>
        );

        const credentials = (
            <>
                {!isTokenActive(!isDesktop) ? (
                    <div className="admin-content-center">
                        <I18n id="transfer.summary.confirm.label" />
                    </div>
                ) : (
                    <div className="admin-content-center pb-3">
                        <I18n
                            id="confirmation.withoutotp.text"
                            component="p"
                            componentProps={{ className: "confirmation__text-without-otp" }}
                        />
                    </div>
                )}

                <div className="admin-content-center">
                    <Field
                        placeholderText={i18nUtils.get(`confirmation.otp.placeholder`)}
                        name="otp"
                        type="otp"
                        idForm={FORM_ID}
                        component={Credential}
                    />
                </div>
            </>
        );

        const containerClassName = `flex-grow align-items-center container-white my-2 py-3 px-md-3 ${
            !isDesktop ? "mb-0" : ""
        }`;

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="debin" />}
                {(!embeddedInV3Shell || isDesktop) && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                        />
                        {isDesktop ? (
                            <>
                                <div className="d-flex">
                                    <div className="view-title">
                                        <div className="d-flex">
                                            <h1 className="mb-0">{i18nUtils.get("requestCredin.title")}</h1>
                                            {control && (
                                                <div className="mx-3">
                                                    <Hint
                                                        defaultValue={configUtils.get(
                                                            "frontend.mobileSignatureControl.text",
                                                            "",
                                                        )}
                                                        classNameGroup="d-flex align-items-center w-100 mb-2"
                                                        classNameHintP="m-0 ms-2"
                                                        alwaysShowMessage
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className="px-0 col-md-8 d-flex align-items-end">
                                                <I18n
                                                    id="requestCredin.summary.label"
                                                    componentProps={{ style: { fontFamily: "Graphik-Light" } }}
                                                />
                                            </div>

                                            <div
                                                className={`col-md-4 debin__totals justify-content-end d-flex mt-md-0 ${isDesktop &&
                                                    "px-0"}`}>
                                                <SelectedAccountsAmount
                                                    list={recipients}
                                                    currency={recipients && recipients[0].amount.currency}
                                                    summaryView
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="admin-content-center d-flex justify-content-center">
                                <I18n
                                    id="requestCredin.summary.label"
                                    component="h3"
                                    componentProps={{ style: { width: "80%" } }}
                                />
                            </div>
                        )}
                    </div>
                )}
                <MainContainer>
                    <Form className="above-the-fold">
                        <Container className={containerClassName} gridClassName="form-content">
                            <CreateCredinSellerSummary isDesktop={isDesktop} seller={seller} />
                        </Container>
                        {recipients &&
                            recipients.map((recipient) => (
                                <Container className={containerClassName} gridClassName="form-content">
                                    <CreateCredinRecipientSummary isDesktop={isDesktop} recipient={recipient} id={id} />
                                </Container>
                            ))}
                        <Container
                            className={`confirmation__container ${containerClassName}`}
                            gridClassName="form-content">
                            <Col className="confirmation__form" lg={5} md={7} sm={12}>
                                {credentials}
                                <Container className="flex-grow align-items-center w-100" gridClassName="form-content">
                                    {continueButton}
                                </Container>
                            </Col>
                        </Container>
                    </Form>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    recipients: debinSelectors.getRecipients(state),
    id: debinSelectors.getId(state),
    control: debinSelectors.getControl(state),
    seller: debinSelectors.getDebinSeller(state),
    fetching: debinSelectors.getFetching(state),
    summary: debinSelectors.getSummary(state),
    cbuList: debinSelectors.getListCbu(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ otp: "" }),
        validationSchema: () =>
            Yup.object().shape({
                otp: Yup.string().required(i18nUtils.get(`${FORM_ID}.otp.error.required`)),
            }),
        handleSubmit: ({ otp }, formikBag) => {
            const { dispatch, seller, recipients, id, cbuList } = formikBag.props;

            const amount = calculateTotalAmountCbuList(cbuList);
            dispatch(debinActions.generateCredin(otp, { ...seller, amount }, recipients, id, formikBag));
        },
    }),
    resizableRoute,
)(GenerateCredin);
